export const API_REGISTER = "https://cafe-notes-api.herokuapp.com/api/register";
